import instance from "@/services/api";

export const sbsCompanyAPI = {
  async getSbsCompanyList(params) {
    return await instance()
      .get("/project/sbs_company/read_all/", { params })
      .then((res) => res?.data);
  },
};
